import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  $fullHeight?: boolean;
  $offsetRight?: string | null;
  $offsetHintWidth?: string;
  $offsetTop?: string | null;
}

function fullHeightStyle({ $fullHeight }: Props) {
  if (!$fullHeight) {
    return css`
      justify-self: flex-start;
      flex: none;
    `;
  }
}

function offsetStyle({ $offsetRight = null, $offsetHintWidth = '14.6rem' }: Props) {
  if ($offsetRight) {
    return css`
      position: absolute;
      right: ${$offsetRight};
      width: ${$offsetHintWidth};
    `;
  }
}

function offsetTopStyle({ $offsetTop = null }: Props) {
  if ($offsetTop) {
    return css`
      position: relative;
      top: ${$offsetTop};
    `;
  }
}

export default styled.div<Props>`
  border-top: 3px solid ${Colours.lime};
  background: ${Colours.whiteDark1};
  padding: 1.5rem 1.4rem;
  font-size: 0.8rem;
  font-weight: 300;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: ${Colours.black};
  flex: 1;

  img {
    width: 28px;
    margin-bottom: 10px;
  }

  p {
    font-size: 0.8rem !important;
    line-height: 21px !important;
  }

  ${fullHeightStyle}
  ${offsetStyle}
  ${offsetTopStyle}
  > span {
    color: ${Colours.black};
    display: block;
    font-weight: 500;
    font-size: 1.066666rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;
